import React from 'react';
import Freeze from './freeze';
import './freeze.scss';

function freeze() {  
  return (
    <div className="App">
      <Freeze />
    </div>
  );
}

export default freeze;